import { privateAxios } from '@/common/api/axios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseTefProductCodesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    provider?: string;
    productCategoryId?: string;
  };
  mapper?: (data: any) => T;
}

export const useTefProductCodes = <T,>({
  filters: { search = '', page, provider, productCategoryId } = {},
  mapper = Mapper.default<T>(),
}: UseTefProductCodesProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['tefProductCodes', search, page, provider, productCategoryId],
    queryFn: () => privateAxios.get('/tef_product_codes', {
      params: {
        search,
        page,
        'q[provider_eq]': provider,
        'q[product_category_id_eq]': productCategoryId,
      },
    }),
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
}
